export default function validateOptions(field) {
  if (field.length < 1) {
    return 'select an interest at least';
  }
}
